<template>
  <div>
    <b-container>
      <b-row>
      <h2>Methods</h2>
      </b-row>
      <b-row>
        <h5>Download the respective methods document by clicking on it.</h5>
      </b-row>
      <b-row>
        <ol>
          <li>
            <b-link href="../methods/main_methods_summary.pdf" download target="_blank">
              Main methods</b-link
            >
          </li>
          <li>
            <b-link href="../methods/Clearing_protocol.pdf" download target="_blank">
              Detailed methods for incubation times with clearing
              solutions</b-link
            >
          </li>
          <li>
            <b-link href="../methods/Vector_Maps_DNA_sequences.pdf" download target="_blank">
              Vector Maps and DNA Sequences</b-link
            >
          </li>
        </ol>
        <br />
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>